import apiClient from "@/shared/api/apiClient4";
import apiClient2 from "@/shared/api/apiClient2";

export const getServiceListWithResponseByCode = async (service_code) => {
  try {
    const { data } = await apiClient.get(
      "/step-runs-public/fetcher-schema/" + service_code
    );
    return data;
  } catch (e) {
    console.error("[services] getServiceListWithResponseByCode", e);
  }
};

export const runChainService = async (
  execution_uuid,
  step_run_uuid,
  tx_id,
  params
) => {
  try {
    const { data } = await apiClient.post(
      `/step-runs-public/run-service/${execution_uuid}/${step_run_uuid}/${tx_id}/`,
      {
        ...params,
      },
      {
        metaData: { isNotificationDisabled: true },
      }
    );
    return data;
  } catch (e) {
    console.error("[services] runChainService", e);
  }
};

export const runChainServiceByIndividual = async (
  execution_uuid,
  step_run_uuid,
  tx_id,
  params
) => {
  try {
    const { data } = await apiClient2.post(
      `/participants-cabinet/run_chain_service_by_individual/${execution_uuid}/${step_run_uuid}/${tx_id}`,
      {
        ...params,
      },
      {
        metaData: { isNotificationDisabled: true },
      }
    );
    return data;
  } catch (e) {
    console.error("[services] runChainServiceByIndividual", e);
    return {
      success: false,
      status: e?.response?.status,
      error: e?.response?.data || e?.message || String(e),
    };
  }
};
